import React, { useEffect, useState } from 'react';
import '../styles/Hero.css';
import autoloadoutsImgSrc from '../assets/autoloadouts.png';
import summonerProfileImgSrc from '../assets/summoner_profile.png';
import themesImgSrc from '../assets/themes.png';
import viewLoadoutsImgSrc from '../assets/view_loadouts.png';
import ingameImgSrc from '../assets/ingame.png';
import braveryImgSrc from '../assets/bravery.png';

const screenshotImages = [
  { src: ingameImgSrc, alt: 'Ingame' },
  { src: viewLoadoutsImgSrc, alt: 'View Loadouts' },
  { src: autoloadoutsImgSrc, alt: 'AutoLoadouts' },
  { src: summonerProfileImgSrc, alt: 'Summoner Profiles' },
  { src: themesImgSrc, alt: 'Themes' },
  { src: braveryImgSrc, alt: 'Ultimate Bravery' },
];

const Hero: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade out
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % screenshotImages.length);
        setFade(true); // Fade in new image
      }, 400); // Duration of fade out
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const { src, alt } = screenshotImages[currentIndex];

  return (
    <section className="hero">
      <div className="container hero-content">
        <div className="hero-text">
          <h1>Enhance Your League Experience</h1>
          <p>
            LeagueTools is your all-in-one companion for League of Legends,
            providing stats and tools to improve your experience.
          </p>
          <div className="cta-buttons">
            <a href="https://leaguetools.dysolix.dev/download" download className="download-btn">
              Download Now
            </a>
            <a href="#features" className="learn-more-btn">
              Learn More
            </a>
          </div>
        </div>
        <div className="hero-image">
          <img src={src} alt={alt} className={fade ? 'fade-in' : 'fade-out'} />
        </div>
      </div>
    </section>
  );
};

export default Hero; 